'use client';

import { c as _c } from "react/compiler-runtime";
import type { CSSProperties } from 'react';
import { Image } from 'react-datocms/image';
import styles from './AvatarStack.module.css';
import type { AvatarStackProps } from './AvatarStack.types';
export function AvatarStack(t0) {
  const $ = _c(32);
  const {
    items,
    maxVisible: t1,
    size: t2,
    border: t3,
    column: t4,
    movement: t5,
    transition: t6,
    ltr: t7,
    ringed: t8,
    offset: t9
  } = t0;
  const maxVisible = t1 === undefined ? 4 : t1;
  const size = t2 === undefined ? 59 : t2;
  const border = t3 === undefined ? 8 : t3;
  const column = t4 === undefined ? 40 : t4;
  const movement = t5 === undefined ? 0.35 : t5;
  const transition = t6 === undefined ? 0.18 : t6;
  const ltr = t7 === undefined ? true : t7;
  const ringed = t8 === undefined ? true : t8;
  const offset = t9 === undefined ? -3 : t9;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  if ($[0] !== border || $[1] !== column || $[2] !== items || $[3] !== ltr || $[4] !== maxVisible || $[5] !== movement || $[6] !== offset || $[7] !== ringed || $[8] !== size || $[9] !== transition) {
    const visibleItems = items.slice(0, maxVisible);
    let t16;
    if ($[16] !== border || $[17] !== column || $[18] !== movement || $[19] !== offset || $[20] !== size || $[21] !== transition) {
      t16 = {
        "--size": size,
        "--border": border,
        "--column": column,
        "--movement": movement,
        "--transition": transition,
        "--offset": offset
      };
      $[16] = border;
      $[17] = column;
      $[18] = movement;
      $[19] = offset;
      $[20] = size;
      $[21] = transition;
      $[22] = t16;
    } else {
      t16 = $[22];
    }
    const cssVars = t16 as CSSProperties;
    t12 = styles.container;
    t13 = cssVars;
    t14 = ltr;
    t15 = ringed;
    t10 = styles.items;
    t11 = visibleItems.map(_temp2);
    $[0] = border;
    $[1] = column;
    $[2] = items;
    $[3] = ltr;
    $[4] = maxVisible;
    $[5] = movement;
    $[6] = offset;
    $[7] = ringed;
    $[8] = size;
    $[9] = transition;
    $[10] = t10;
    $[11] = t11;
    $[12] = t12;
    $[13] = t13;
    $[14] = t14;
    $[15] = t15;
  } else {
    t10 = $[10];
    t11 = $[11];
    t12 = $[12];
    t13 = $[13];
    t14 = $[14];
    t15 = $[15];
  }
  let t16;
  if ($[23] !== t10 || $[24] !== t11) {
    t16 = <ul className={t10}>{t11}</ul>;
    $[23] = t10;
    $[24] = t11;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== t12 || $[27] !== t13 || $[28] !== t14 || $[29] !== t15 || $[30] !== t16) {
    t17 = <div className={t12} style={t13} data-ltr={t14} data-ringed={t15}>{t16}</div>;
    $[26] = t12;
    $[27] = t13;
    $[28] = t14;
    $[29] = t15;
    $[30] = t16;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  return t17;
}
function _temp2(item) {
  return <li key={item.name}><span className={styles.name}>{Array.from(item.name).map(_temp)}</span><div className={styles.avatarHolder}><span className={styles.avatar}>{item.responsiveImage ? <Image data={item.responsiveImage} layout="fill" objectFit="cover" /> : <img src={item.src} alt={item.alt ?? item.name} />}</span></div></li>;
}
function _temp(char, i) {
  return <span key={`${i}-${char}`} style={{
    "--i": i
  } as CSSProperties}>{char}</span>;
}